import React, { useState } from 'react';
import { Star } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { mockData } from '../mock';

const TestimonialsSection = () => {
  const [showReviewForm, setShowReviewForm] = useState(false);
  const [submittedReviews, setSubmittedReviews] = useState([]);
  const [reviewForm, setReviewForm] = useState({
    name: '',
    designation: '',
    location: '',
    rating: 5,
    testimonial: ''
  });

  const handleReviewChange = (field, value) => {
    setReviewForm({ ...reviewForm, [field]: value });
  };

  const handleReviewSubmit = (e) => {
    e.preventDefault();
    const newReview = {
      ...reviewForm,
      id: Date.now(),
      date: new Date().toLocaleDateString()
    };
    setSubmittedReviews([newReview, ...submittedReviews]);
    setReviewForm({
      name: '',
      designation: '',
      location: '',
      rating: 5,
      testimonial: ''
    });
    setShowReviewForm(false);
  };

  const allTestimonials = [
    ...submittedReviews.map(r => ({
      name: r.name,
      designation: r.designation,
      location: r.location,
      testimonial: r.testimonial,
      rating: r.rating
    })),
    ...mockData.testimonials
  ];

  return (
    <section id="testimonials" className="testimonials-section" data-testid="testimonials-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Client Success Stories</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">Hear from our clients about their investment journey with us</p>
        </div>

        {/* Write a Review Button */}
        <div className="review-cta-container">
          <Button
            className="btn-secondary"
            data-testid="write-review-btn"
            onClick={() => setShowReviewForm(!showReviewForm)}
            style={{ marginBottom: '40px' }}
          >
            {showReviewForm ? 'Cancel' : 'Write a Review'}
          </Button>
        </div>

        {/* Review Form */}
        {showReviewForm && (
          <div className="review-form-container" data-testid="review-form">
            <Card className="review-form-card">
              <CardContent className="review-form-content">
                <h3 className="review-form-title">Share Your Experience</h3>
                <form className="review-form" onSubmit={handleReviewSubmit}>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">Your Name *</label>
                      <input
                        type="text"
                        className="form-input"
                        data-testid="review-name-input"
                        value={reviewForm.name}
                        onChange={(e) => handleReviewChange('name', e.target.value)}
                        placeholder="Full Name"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Designation</label>
                      <input
                        type="text"
                        className="form-input"
                        data-testid="review-designation-input"
                        value={reviewForm.designation}
                        onChange={(e) => handleReviewChange('designation', e.target.value)}
                        placeholder="e.g., Business Owner"
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">Location</label>
                      <input
                        type="text"
                        className="form-input"
                        data-testid="review-location-input"
                        value={reviewForm.location}
                        onChange={(e) => handleReviewChange('location', e.target.value)}
                        placeholder="City"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Rating</label>
                      <div className="rating-selector" data-testid="review-rating">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <button
                            key={star}
                            type="button"
                            className={`star-button ${star <= reviewForm.rating ? 'active' : ''}`}
                            onClick={() => handleReviewChange('rating', star)}
                          >
                            <Star size={24} fill={star <= reviewForm.rating ? '#00A86B' : 'none'} />
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Your Review *</label>
                    <textarea
                      className="form-textarea"
                      data-testid="review-text-input"
                      value={reviewForm.testimonial}
                      onChange={(e) => handleReviewChange('testimonial', e.target.value)}
                      placeholder="Share your experience with APK FINTECH..."
                      rows="4"
                      required
                    />
                  </div>
                  <Button type="submit" className="btn-primary review-submit-btn" data-testid="review-submit-btn">
                    Submit Review
                  </Button>
                </form>
              </CardContent>
            </Card>
          </div>
        )}

        <div className="testimonials-grid">
          {allTestimonials.map((testimonial, index) => (
            <Card key={index} className="testimonial-card" data-testid={`testimonial-card-${index}`}>
              <CardContent className="testimonial-content">
                <div className="testimonial-stars">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <span key={i} className="star">&#9733;</span>
                  ))}
                </div>
                <p className="testimonial-text">"{testimonial.testimonial}"</p>
                <div className="testimonial-author">
                  <div className="author-avatar">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div className="author-info">
                    <h4 className="author-name">{testimonial.name}</h4>
                    <p className="author-designation">{testimonial.designation}</p>
                    <p className="author-location">{testimonial.location}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
